/**
 * 消息弹窗
 * @param {string} text 内容
 * @param {string} title 标题
 * @param {string} type 类型 s=success,w=warning,e=error,i=info
 * @param {function} confirmBc 确认回调
 * @param {function} cancelBc 取消回调
 */
export function messageBox (text, type, title, confirmBc, cancelBc) {
  this.$confirm(text, title || '提示', {
    type: type === 's' ? 'success' : type === 'w' ? 'warning' : type === 'e' ? 'error' : type === 'i' ? 'info' : '',
    showCancelButton: !!cancelBc,
    dangerouslyUseHTMLString: true
  }).then(() => {
    if (confirmBc && typeof confirmBc === 'function') confirmBc()
  }).catch(() => {
    if (cancelBc && typeof cancelBc === 'function') cancelBc()
  })
}
/**
 * 消息提示
 * @param {string} text 内容
 * @param {string} type 类型 s=success,w=warning,e=error,i=info
 */
export function message (text, type) {
  this.$message({
    type: type === 's' ? 'success' : type === 'w' ? 'warning' : type === 'e' ? 'error' : 'info',
    message: text
  })
}



// WEBPACK FOOTER //
// ./src/utils/msg.js